import { FC } from 'react';
import { SEVERITY, SeverityLevel } from '@silverfort/sf-components';

type Props = {
    riskLevel?: SEVERITY;
};

const RiskLevelCell: FC<Props> = ({ riskLevel = SEVERITY.LOW }) => {
    return <div className="w-9"><SeverityLevel severity={riskLevel} /></div>;
};

export default RiskLevelCell;
